var _g, _path, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNonRedtailConnect = function SvgNonRedtailConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 290,
    height: 90,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#nonRedtailConnect_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 25,
    y: 13,
    fill: "url(#nonRedtailConnect_svg__b)",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#nonRedtailConnect_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45 20c-6.282 0-11.375 1.819-11.375 4.063v17.875C33.625 44.18 38.718 46 45 46s11.375-1.819 11.375-4.062V24.062C56.375 21.82 51.282 20 45 20m0 23.563c-5.011 0-8.196-1.209-8.937-1.92v-3.697c2.082.945 5.306 1.554 8.891 1.554s6.856-.61 8.984-1.554v3.698c-.742.71-3.926 1.919-8.938 1.919m8.938-8.42c-.742.71-3.926 1.92-8.938 1.92s-8.196-1.21-8.937-1.92v-3.697C38.145 32.391 41.369 33 45 33s6.81-.61 8.938-1.555zm0-6.5c-.742.71-3.926 1.92-8.984 1.92s-8.15-1.21-8.891-1.92v-4.285c.741-.712 3.925-1.92 8.937-1.92s8.196 1.208 8.938 1.919z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F5F7",
    strokeWidth: 2,
    d: "M225 33H65"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#nonRedtailConnect_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 225,
    y: 13,
    fill: "url(#nonRedtailConnect_svg__e)",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#nonRedtailConnect_svg__f)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#nonRedtailConnect_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257.501 41.155-3.913-2.258v1.352H247v1.812h6.588v1.353zM233.406 37.078a4.99 4.99 0 0 0 4.984 4.984h1.36V40.25h-1.36a3.175 3.175 0 0 1-3.171-3.172 3.175 3.175 0 0 1 3.171-3.172h1.36v-1.812h-1.36a4.99 4.99 0 0 0-4.984 4.984M253.343 28.922a4.99 4.99 0 0 0-4.984-4.985H247v1.813h1.359a3.175 3.175 0 0 1 3.172 3.172 3.175 3.175 0 0 1-3.172 3.171H247v1.813h1.359a4.99 4.99 0 0 0 4.984-4.984M239.75 23.938h-7.25v1.812h7.25zM246.093 22.125h-5.437v5.437h5.437zM246.093 30.281h-5.437v5.438h5.437zM246.093 38.437h-5.437v5.437h5.437z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#nonRedtailConnect_svg__h)",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M155 33H77"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "nonRedtailConnect_svg__a",
    width: 90,
    height: 90,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4613_75047"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4613_75047",
    result: "effect2_dropShadow_4613_75047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4613_75047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "nonRedtailConnect_svg__c",
    width: 34,
    height: 34,
    x: 28,
    y: 17,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4613_75047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4613_75047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "nonRedtailConnect_svg__d",
    width: 90,
    height: 90,
    x: 200,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4613_75047"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4613_75047",
    result: "effect2_dropShadow_4613_75047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4613_75047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "nonRedtailConnect_svg__f",
    width: 33,
    height: 33,
    x: 228.5,
    y: 17.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4613_75047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4613_75047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nonRedtailConnect_svg__b",
    x1: 45,
    x2: 45,
    y1: 13,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CABFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5850EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nonRedtailConnect_svg__e",
    x1: 245,
    x2: 245,
    y1: 13,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C727F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nonRedtailConnect_svg__h",
    x1: 156.592,
    x2: 75.408,
    y1: 31.5,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7269F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7269F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nonRedtailConnect_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232.5 20.5h25v25h-25z"
  })))));
};
export default SvgNonRedtailConnect;